import { DefaultOptions, QueryClient, UseMutationOptions } from '@tanstack/react-query';

export const queryConfig = {
  queries: {
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 1000 * 60
  }
} satisfies DefaultOptions;

export type ApiFnReturnType<TApiFn extends (...args: any) => Promise<any>> = Awaited<ReturnType<TApiFn>>;

export type QueryConfig<TQueryFn extends (...args: any) => any> = Omit<ReturnType<TQueryFn>, 'queryKey' | 'queryFn'>;

export type MutationConfig<TMutationFn extends (...args: any) => Promise<any>> = UseMutationOptions<
  ApiFnReturnType<TMutationFn>,
  Error,
  Parameters<TMutationFn>[0]
>;

export const queryClient = new QueryClient({
  defaultOptions: queryConfig
});
